// SignupPrompt.jsx
// Modern component for prompting users to create an account with call-to-action design

import React from 'react';
import { styles } from './styles';

const SignupPrompt = ({ onNavigateToSignup }) => {
  return (
    <div style={styles.signupSection}>
      <p style={styles.signupText}>
        New to Redbird Markets?
      </p>
      <button
        style={styles.signupButton}
        onClick={onNavigateToSignup}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#CE1126';
          e.target.style.color = 'white';
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 8px 24px rgba(206, 17, 38, 0.3)';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'transparent';
          e.target.style.color = '#CE1126';
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = 'none';
        }}
      >
        Create Your Account
      </button>
    </div>
  );
};

export default SignupPrompt;